import React, { useContext, useEffect, useState } from "react";
import { TiThMenu } from "react-icons/ti";
import OrderDetail from "./OrderDetail";
import { useLocation, useNavigate } from "react-router-dom";
import AlertContext from "../../../../Context/Alert/AlertContext";
import SocketContext from "../../../../Context/Socket/SocketContext";
import axios from "axios";
import { BaseURL } from "../../../../Files/BaseURL";
import { formatDateForInput } from "../../../../Files/UseFunction";
import {
  FaDownload,
  FaFileAlt,
  FaFileImage,
  FaFileVideo,
  FaRegFilePdf,
  FaTimes,
} from "react-icons/fa";
import { BsFiletypeDocx } from "react-icons/bs";
import { MdFolderZip } from "react-icons/md";

const ChatDetail = () => {
  const [OrderStatus, setOrderStatus] = useState(false);
  const [UserData, setUserData] = useState(null);
  const [Conversation, setConversation] = useState([]);
  const [TotalPages, setTotalPages] = useState(null);
  const [Page, setPage] = useState(null);
  const [Chats, setChats] = useState([]);
  const [message, setmessage] = useState("");
  const [ChatFile, setChatFile] = useState(null);
  const [FileName, setFileName] = useState(null);
  const [UploadedFile, setUploadedFile] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  const alertcontext = useContext(AlertContext);
  const { showAlert } = alertcontext;

  const socketcontext = useContext(SocketContext);
  const { OnlineUsers, SocetConnection, isUserOnline } = socketcontext;

  const fetchuser = async (id) => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/getusers/getuser/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": authToken,
          },
        }
      );
      if (response.data.success) {
        setUserData(response.data.user);
      } else {
        showAlert(response.data.message, "danger");
      }
    } catch (error) {
      showAlert(error.message, "danger");
    }
  };

  const fetchconversation = async (id) => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/messaging/getMessages/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": authToken,
          },
        }
      );
      if (response.data.success) {
        setConversation(response.data.messages);
        setTotalPages(response.data.totalPages);
        setPage(response.data.page);
      } else {
        showAlert(response.data.message, "danger");
      }
    } catch (error) {
      showAlert(error.message, "danger");
    }
  };

  const updateSeenChat = async (id) => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/messaging/markAsSeen/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": authToken,
          },
        }
      );
      if (response.ok) {
      }
    } catch (error) {
      showAlert(error.message, "danger");
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const userid = queryParams.get("user");
    const chatid = queryParams.get("chatid");
    if (userid !== null) {
      console.log(123);
      fetchuser(userid);
    } else {
      console.log(456);
      setUserData(null);
    }
    if (chatid !== null) {
      console.log(768);
      fetchconversation(chatid);
      updateSeenChat(chatid);
    } else {
      console.log(90);
      setConversation([]);
      setPage(1);
      setTotalPages(null);
    }
  }, [location.search]);

  useEffect(() => {
    if (SocetConnection) {
      const handleMessage = (data) => {
        const queryParams = new URLSearchParams(location.search);
        const chatid = queryParams.get("chatid");
        const userid = queryParams.get("user");

        // Ensure chatid and data.Chat_id are strings for comparison
        const normalizedChatId = chatid ? chatid.trim() : "";
        const normalizedDataChatId = data.Chat_id ? data.Chat_id.trim() : "";

        console.log(
          "data.Chat_id:",
          data.Chat_id,
          "type:",
          typeof data.Chat_id
        );

        if (normalizedChatId && normalizedDataChatId) {
          if (normalizedChatId === normalizedDataChatId) {
            console.log(123);
            fetchconversation(chatid);
            updateSeenChat(chatid);
          }
        }
      };

      // Attach the event handler
      SocetConnection.on("message", handleMessage);

      // Cleanup function to remove the event handler
      return () => {
        SocetConnection.off("message", handleMessage);
      };
    }
  }, [SocetConnection, location.search]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage(e);
    }
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    const queryParams = new URLSearchParams(location.search);
    const userid = queryParams.get("user");

    if (userid) {
      if (message !== "" || ChatFile) {
        if (SocetConnection) {
          // Create temporary message for immediate display
          const tempMessage = {
            tag: "Sender",
            message: message,
            date: new Date(),
            File: ChatFile
              ? {
                  Link: URL.createObjectURL(ChatFile),
                  Name: FileName,
                }
              : null,
          };

          // Add message to conversation immediately
          setConversation((prev) => [...prev, tempMessage]);

          // Emit socket event
          SocetConnection.emit("new message", {
            UserID: userid,
            covnersation: message,
            File: {
              Link: UploadedFile,
              Name: FileName,
            },
          });

          // Clear input fields
          setmessage("");
          setUploadedFile(null);
          setFileName(null);
          setChatFile(null);
        }
      }
    }
  };

  const FileUpload = async (e) => {
    try {
      const file = e.target.files[0];
      setChatFile(file);
      setFileName(file.name);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("filename", file.name);

      const authToken = localStorage.getItem("p@token");
      const response = await fetch(`${BaseURL}/api/messaging/upload-docs`, {
        method: "POST",
        headers: {
          "auth-token": authToken,
        },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        setUploadedFile(data?.location);
      } else {
        showAlert("File not uploaded, try again", "danger");
      }
    } catch (error) {
      console.error("File upload error:", error);
      showAlert("File not uploaded, try again", "danger");
    }
  };

  const renderFileIcon = (file) => {
    const fileType = file;

    console.log(file);
    switch (fileType) {
      case "image":
        return <FaFileImage className="text-2xl w-full text-primarygreen" />;
      case "video":
        return <FaFileVideo className="text-2xl w-full text-primarygreen" />;
      case "pdf":
        return <FaRegFilePdf className="text-2xl w-full text-red-500" />;
      case "application":
        return <FaRegFilePdf className="text-2xl w-full text-red-500" />;
      case "doc":
        return <BsFiletypeDocx className="text-2xl w-full text-blue-500" />;
      case "docx":
        return <BsFiletypeDocx className="text-2xl w-full text-blue-500" />;
      case "zip":
        return <MdFolderZip className="text-2xl w-full text-gray-400" />;
      default:
        return <FaFileAlt className="text-2xl w-full text-primarygreen" />;
    }
  };

  return (
    <>
      {OrderStatus && <OrderDetail setOrderStatus={setOrderStatus} />}
      <div className="h-[calc(100vh-100px)] md:h-[calc(100vh-155px)]">
        <div className="bg-white font-pop  w-full px-2 py-2">
          {UserData !== null && (
            <div className="bg-white font-pop w-full px-2 md:px-6">
              <div className="flex flex-row md:flex-row justify-between md:items-center">
                <div className="flex flex-row gap-2 items-center">
                  {UserData?.ProfilePhoto ? (
                    <img
                      src={UserData?.ProfilePhoto}
                      alt=""
                      className="rounded-full w-8 md:w-12 h-8 md:h-12"
                    />
                  ) : (
                    <div className="w-8 md:w-12 h-8 md:h-12 rounded-full font-pop bg-gray-400 flex items-center justify-center">
                      <span className="text-white">
                        {UserData?.FirstName && UserData?.FirstName?.charAt(0)}
                      </span>
                    </div>
                  )}
                  <div className="flex flex-col">
                    <h2 className="text-sm md:text-lg font-semibold">
                      {UserData?.FirstName} {UserData?.LastName}
                    </h2>
                    <p className="text-xs md:text-base text-gray-400">
                      Last connect 8 hours ago
                    </p>
                  </div>
                </div>
                <div className="hidden lg:flex flex-row gap-2 items-center">
                  <TiThMenu
                    className="text-xl block"
                    onClick={() => {
                      setOrderStatus(true);
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="flex flex-col px-2 md:px-6 py-2 md:py-4 gap-6 h-[100%] justify-between">
          <div className="h-[calc(100vh-150px)] overflow-y-auto">
            <div className="flex flex-col gap-2">
              {Conversation?.length > 0 &&
                Conversation?.map((item, index) => (
                  <div
                    className={`${
                      item.tag == "Sender"
                        ? "flex flex-col justify-end"
                        : "flex flex-col justify-start"
                    } my-1 gap-1`}
                  >
                    {item?.File?.Link && (
                      <div
                        className={`p-2 rounded w-fit shadow-md font-pop flex items-end ${
                          item.tag == "Sender"
                            ? "bg-primarygreen/50 self-end text-white"
                            : "bg-gray-300"
                        }`}
                      >
                        <div className="flex flex-col gap-2">
                          {item?.File && renderFileIcon(item?.File?.Link)}
                          <span className="ml-2">{item?.File?.Name}</span>
                        </div>
                        <a
                          href={item?.File?.Link}
                          download={true}
                          target="_blank"
                        >
                          <FaDownload className="ml-2 text-3xl text-gray-500 cursor-pointer" />
                        </a>
                      </div>
                    )}
                    <div
                      className={`${
                        item.tag == "Sender"
                          ? "bg-primarygreen self-end text-white"
                          : "bg-[#E8E8E8]"
                      } rounded-xl py-2 px-4 md:max-w-[75%] lg:max-w-[65%] max-w-[60%] lg:break-all`}
                    >
                      <p className="text-sm md:text-base whitespace-pre-wrap break-words overflow-hidden">
                        {item?.message}
                      </p>
                    </div>
                    <p
                      className={`${
                        item.tag == "Sender" ? "text-right" : "text-left"
                      } text-xs`}
                    >
                      {formatDateForInput(item?.date)}
                    </p>
                  </div>
                ))}
            </div>
          </div>
          <div className="flex flex-row font-pop justify-between items-center bg-[#E8E8E8] rounded-2xl py-1 md:py-2 px-2 md:px-4">
            <div className="flex w-[100%] flex-row items-center gap-2">
              <label htmlFor="fileupload" className="relative cursor-pointer">
                <img
                  src="../../Assets/Prop/docattach.png"
                  alt=""
                  className="w-8 h-8"
                />
                <input
                  type="file"
                  id="fileupload"
                  onChange={FileUpload}
                  className="hidden"
                />
              </label>
              <div className="flex gap-2 w-full">
                {UploadedFile !== "" && UploadedFile !== null && (
                  <div className="bg-gray-300 p-2 rounded shadow-md font-pop flex items-center">
                    <div className="flex flex-col gap-2">
                      {ChatFile && renderFileIcon(ChatFile)}
                      <span className="ml-2 w-max text-xs">{FileName}</span>
                    </div>
                    <FaTimes
                      className="ml-2 text-red-500 cursor-pointer"
                      onClick={() => {
                        setChatFile(null);
                        setFileName(null);
                        setUploadedFile(null);
                      }}
                    />
                  </div>
                )}
                <input
                  type="text"
                  value={message}
                  onChange={(e) => setmessage(e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder="Message..."
                  className="text-lg w-[100%] font-normal border-transparent outline-none focus:outline-none focus:border-transparent active:border-transparent active:outline-none bg-transparent"
                />
              </div>
            </div>
            <img
              src="../../Assets/Prop/messagesend.png"
              alt=""
              onClick={handleSendMessage}
              className="w-4 h-4 md:w-8 md:h-8 cursor-pointer"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatDetail;
